import AddTemplate from "./AddTemplate";

export default AddTemplate;